<template>
  <el-col :span="12" v-if="scenesType === 'form'">
    <el-form-item style="position: relative">
      <!--
                    widgetType控件类型，1-文本框、2-下拉框、3-复选、4-单选、5-时间控件、6-数字等
                    控件是否可编辑 字符串    "true"-可编辑，"false"-不可编辑
        -->
      <!-- {{topicTslGroup?`-( ${getDicValue('iot_topic_tsl_group',topicTslGroup)})`:''}} 分类topicTslGroup -->
      <span slot="label">
        {{ label }}
        <i style="position: absolute; right: 10px" v-if="showUnit">{{ iot_tsl_data_unit[showUnit] }}</i>
      </span>
      <!-- int64: -9223372036854775808 ~ 9223372036854775807 -->
      <template v-if="`${type}` === '1' && dataType === 'Long'">
        <el-input v-model="val" :disabled="isEditWidget === 'false'" :style="{ width: width }" @input="handleLong" @change="onChange"></el-input>
      </template>
      <!-- int32: -2147483648 ~ 2147483647 -->
      <template v-if="`${type}` === '1' && dataType === 'Integer'">
        <el-input v-model="val" :disabled="isEditWidget === 'false'" :style="{ width: width }" @input="handleInt" @change="onChange">
        </el-input>
      </template>
      <template v-if="`${type}` === '1' && dataType !== 'Long' && dataType !== 'Integer'">
        <el-input v-model="val" :disabled="isEditWidget === 'false'" :style="{ width: width }" :maxlength="dataLen" @change="onChange">
          <!-- <template v-if="item.showUnit" slot="append" style="background-color: #ffffff; padding: 0px 6px;font-size: 12px;">{{iot_tsl_data_unit[item.showUnit]}}</template> -->
        </el-input>
      </template>

      <template v-if="`${type}` === '2'">
        <custom-select v-model="val" :code="dicGroup" :disabled="isEditWidget === 'false'" :width="width" @change="onChange"></custom-select>
      </template>
      <template v-if="`${type}` === '3'">
        <custom-select v-model="val" :code="dicGroup" :disabled="isEditWidget === 'false'" :width="width" @change="onChange"></custom-select>
      </template>
      <template v-if="`${type}` === '4'">
        <custom-select v-model="val" :code="dicGroup" :disabled="isEditWidget === 'false'" @change="onChange" :width="width"></custom-select>
      </template>
      <template v-if="`${type}` === '5'">
        <!-- item.dataFormat  数据格式 -->
        <el-time-picker v-model="val" format="HH:mm" value-format="HHmm" :disabled="isEditWidget === 'false'" @change="onChange" :style="{ width: width }"></el-time-picker>
      </template>
      <template v-if="`${type}` === '6'">
        <el-input type="number" v-model.number="val" :disabled="isEditWidget === 'false'" @input="handleEdit" @change="onChange" :style="{ width: width }" :maxlength="dataLen"></el-input>
      </template>
      <template v-if="`${type}` === '7'">
        <el-switch
          v-model="val"
          active-value="1"
          inactive-value="0"
          active-color="#13ce66"
          :inactive-text="getDicValue(dicGroup, 0)"
          :active-text="getDicValue(dicGroup, 1)"
          @change="onChange"
        ></el-switch>
      </template>
      <template v-if="`${type}` === '8'">
        <custom-date-picker v-model="val" type="datetime" align="right" :disabled="isEditWidget === 'false'" @change="onChange" :style="{ width: width }"></custom-date-picker>
      </template>
      <template v-if="`${type}` === '9'">
        <el-button type="primary">{{ label }}</el-button>
      </template>
    </el-form-item>
  </el-col>

  <div v-else>
    <!-- int64: -9223372036854775808 ~ 9223372036854775807 -->
    <template v-if="`${type}` === '1' && dataType === 'Long'">
      <el-input v-model="val" :disabled="isEditWidget === 'false'" :style="{ width: width }" @input="handleLong" @change="onChange">
      </el-input>
    </template>
    <!-- int32: -2147483648 ~ 2147483647 -->
    <template v-if="`${type}` === '1' && dataType === 'Integer'">
      <el-input v-model="val" :disabled="isEditWidget === 'false'" :style="{ width: width }" :maxlength="dataLen" @input="handleInt" @change="onChange">
      </el-input>
    </template>
    <template v-if="`${type}` === '1' && dataType !== 'Long' && dataType !== 'Integer'">
      <el-input v-model="val" :disabled="isEditWidget === 'false'" :style="{ width: width }" :maxlength="dataLen" @change="onChange" @input="handleEdit">
        <!-- <template v-if="item.showUnit" slot="append" style="background-color: #ffffff; padding: 0px 6px;font-size: 12px;">{{iot_tsl_data_unit[item.showUnit]}}</template> -->
      </el-input>
    </template>
    <template v-if="`${type}` === '2'">
      <custom-select v-model="val" :code="dicGroup" :disabled="isEditWidget === 'false'" :width="width" @change="onChange"></custom-select>
    </template>
    <template v-if="`${type}` === '3'">
      <custom-select v-model="val" :code="dicGroup" :disabled="isEditWidget === 'false'" :width="width" @change="onChange"></custom-select>
    </template>
    <template v-if="`${type}` === '4'">
      <custom-select v-model="val" :code="dicGroup" :disabled="isEditWidget === 'false'" @change="onChange" :width="width"></custom-select>
    </template>
    <template v-if="`${type}` === '5'">
      <!-- item.dataFormat  数据格式 -->
      <el-time-picker v-model="val" format="HH:mm" value-format="HHmm" :disabled="isEditWidget === 'false'" @change="onChange" :style="{ width: width }"></el-time-picker>
    </template>
    <template v-if="`${type}` === '6'">
      <el-input type="number" v-model.number="val" :disabled="isEditWidget === 'false'" @input="handleEdit" @change="onChange" :style="{ width: width }" :maxlength="dataLen"></el-input>
    </template>
    <template v-if="`${type}` === '7'">
      <el-switch
        v-model="val"
        active-value="1"
        inactive-value="0"
        active-color="#13ce66"
        :inactive-text="getDicValue(dicGroup, 0)"
        :active-text="getDicValue(dicGroup, 1)"
        @change="onChange"
      ></el-switch>
    </template>
    <template v-if="`${type}` === '8'">
      <custom-date-picker v-model="val" type="datetime" align="right" :disabled="isEditWidget === 'false'" @change="onChange" :style="{ width: width }"></custom-date-picker>
    </template>
    <template v-if="`${type}` === '9'">
      <el-button type="primary">{{ label }}</el-button>
    </template>
  </div>
</template>

<script>
// import moment from 'moment';

export default {
  props: {
    label: { type: String },
    type: [String, Number],
    value: [String, Array, Number, Date],
    isEditWidget: [Boolean, String, Number],
    dicGroup: { type: String },
    dataLen: [String, Number],
    dataType: { type: String, default: '' },
    showUnit: { type: String, default: '' },
    width: { type: String, default: '100%' },
    scenesType: { type: String, default: 'form' },
    // 分类
    topicTslGroup: { type: String },

    // width: { type: String },
  },
  data() {
    return {
      val: this.value,
      iot_tsl_data_unit: {},
    };
  },
  watch: {
    value() {
      this.val = this.value;
    },
  },
  mounted() {
    this.val = this.value;
    if (this.showUnit) {
      this.getDictionary('iot_tsl_data_unit', (data) => {
        this.iot_tsl_data_unit = this.$transformDicValue(data.iot_tsl_data_unit);
      });
    }
  },
  methods: {
    // 选中值
    onChange: function () {
      if (`${this.type}` === '6' && `${this.val}`.length > +this.dataLen) {
        const val = `${this.val}`.slice(0, +this.dataLen);
        // this.value = +val;
        this.val = +val;
      }
      this.$emit('input', this.val);
      this.$emit('change', this.val);
    },
    // 在 Input 值改变时触发
    handleEdit(e) {
      let value = e.replace(/[^\d]/g, ''); // 只能输入数字
      value = value.replace(/^0+(\d)/, '$1'); // 第一位0开头，0后面为数字，则过滤掉，取后面的数字
      value = value.replace(/(\d{15})\d*/, '$1'); // 最多保留15位整数
      this.val = value;
    },
    handleLong(e) {
      if (Number(e) > 18446744073709552000) {
        this.val = '18446744073709552000';
      } else if (Number(e) < -9223372036854775808) {
        this.val = '-9223372036854775808';
      }
    },
    handleInt(e) {
      if (Number(e) > 4294967294) {
        this.val = '4294967294';
      } else if (Number(e) < -2147483648) {
        this.val = '-2147483648';
      }
    },
    // 时间转换
    // onDatetime:function(time){
    //   // let localTime=new Date(time).toUTCString()
    //   let fomatTime= new Date(time)
    //   this.$emit("input", fomatTime);
    //   console.log(time,fomatTime)
    // }
  },
};
</script>
<style></style>
